// extracted by mini-css-extract-plugin
export default {"snackbar":"Snackbar_snackbar__fQX4g","success":"Snackbar_success__MvKWD","error":"Snackbar_error__m-qVY"};